import { createSlice } from "@reduxjs/toolkit";
import { userAccountApi } from "@/redux/apis";
import { pageState } from "@/redux/types";
import { UserAccountState } from "./types";

const initialState: UserAccountState = {
  account: {
    items: [],
    page: pageState,
  },
  accountHistory: {
    items: [],
    page: pageState,
  },
};

export const userAccountSlice = createSlice({
  name: "userAccount",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(userAccountApi.endpoints.getUserAccounts.matchFulfilled, (state, { payload }) => {
      const { items, page } = payload.data;
      state.account.items = items;
      state.account.page = page;
    });
    builder.addMatcher(userAccountApi.endpoints.getUserAccountHistory.matchFulfilled, (state, { payload }) => {
      const { items, page } = payload.data;
      state.accountHistory.items = items;
      state.accountHistory.page = page;
    });
  },
});

export default userAccountSlice.reducer;
